(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.shopify-section') || this;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

        onScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      const footerGif = document.querySelector('.gif-footer-wrapper');

      if (footerGif) {
        const gifBounds = footerGif.getBoundingClientRect();
        const gifVisibile =
          gifBounds.top < window.innerHeight &&
          gifBounds.bottom > 0;

        if (gifVisibile) {
          if (!this.hiddenByFooterGif) {
            this.closeMenuDisclosure();

            this.header.classList.add(
              'shopify-section-header-sticky',
              'shopify-section-header-hidden',
              'animate'
            );

            this.hiddenByFooterGif = true;
          }

          this.currentScrollTop = scrollTop;
          return;
        }
      }

      if (this.hiddenByFooterGif) {
        this.hiddenByFooterGif = false;

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add(
            'shopify-section-header-sticky',
            'animate'
          );

          this.header.classList.remove(
            'shopify-section-header-hidden'
          );
        }
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
// Nasconde il menu scendendo e lo mostra risalendo.
if (
  scrollTop <= this.headerBounds.top ||
  scrollTop < this.currentScrollTop
) {
  this.header.classList.remove('header-menu-hidden');
} else if (
  scrollTop > this.currentScrollTop &&
  scrollTop > this.headerBounds.bottom
) {
  this.header.classList.add('header-menu-hidden');
}

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }


    hide() {
  if (this.headerIsAlwaysSticky) return;

  const wasSticky = this.header.classList.contains(
    'shopify-section-header-sticky'
  );

  this.header.classList.add(
    'shopify-section-header-hidden',
    'shopify-section-header-sticky'
  );

  this.header.classList.toggle('animate', wasSticky);

  this.closeMenuDisclosure();
  this.closeSearchModal();
}


    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
